import React, { Component } from 'react';
import Card from 'material-ui-beta/Card';

import NavItem from '../admin-nav/NavItem';
import NavItems from '../admin-nav/NavItems';

import logo from '../../img/nica-logo.svg';
import ico_files from '../../img/ic_insert_drive_file_black_36px.svg';
import ico_files_selected from '../../img/ic_insert_drive_file_selected_36px.svg';
import ico_location from '../../img/ic_location_on_black_36px.svg';
import ico_location_selected from '../../img/ic_location_on_selected_36px.svg';
import ico_list from '../../img/ic_list_black_36px.svg';
import ico_list_selected from '../../img/ic_list_selected_36px.svg';
import history from '../../img/baseline-history-24px.svg';
import history_selected from '../../img/baseline-history-selected-24px.svg';
import ico_report from '../../img/baseline-table_chart-24px.svg';
import ico_report_selected from '../../img/baseline-table_chart-selected-24px.svg';

import './Nav.css';

class Nav extends Component {

    isUserAdmin() {
        return this.props.user && this.props.user.isAdmin;
    }

    render() {
        return (
            <div className="admin-nav-container flex">
                <Card className="admin-nav-card flex1">
                    <div>
                        <div className="admin-nav-card-top">
                            <div>
                                <img src={logo} className="admin-nav-logo" alt="nica logo" />
                            </div>
                            <div className="admin-nav-card-title oswald">
                                Admin Panel
                            </div>
                        </div>
                        <div className="admin-nav-card-items">
                            <div>
                                <NavItem
                                    title={NavItems.location_manager}
                                    icon={ico_location}
                                    selectedIcon={ico_location_selected}
                                    onClick={this.props.onNavItemClick}
                                    selectedItem={this.props.selectedItem} />
                            </div>
                            <div>
                                <NavItem
                                    title={NavItems.member_resources}
                                    icon={ico_list}
                                    selectedIcon={ico_list_selected}
                                    onClick={this.props.onNavItemClick}
                                    selectedItem={this.props.selectedItem} />
                            </div>
                            <div>
                                <NavItem
                                    title={NavItems.purchase_history}
                                    icon={history}
                                    selectedIcon={history_selected}
                                    onClick={this.props.onNavItemClick}
                                    selectedItem={this.props.selectedItem} />
                            </div>
                            {this.isUserAdmin() ?
                                <div>
                                    <div>
                                        <NavItem
                                            title={NavItems.admin_resources}
                                            icon={ico_files}
                                            selectedIcon={ico_files_selected}
                                            onClick={this.props.onNavItemClick}
                                            selectedItem={this.props.selectedItem}/>
                                    </div>
                                    <div>
                                        <NavItem
                                            title={NavItems.admin_query_report}
                                            icon={ico_report}
                                            selectedIcon={ico_report_selected}
                                            onClick={this.props.onNavItemClick}
                                            selectedItem={this.props.selectedItem}/>
                                    </div>
                                    <div>
                                        <NavItem
                                            title={NavItems.admin_location_report}
                                            icon={ico_report}
                                            selectedIcon={ico_report_selected}
                                            onClick={this.props.onNavItemClick}
                                            selectedItem={this.props.selectedItem}/>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>

                </Card>


            </div>
        )
    }

}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/admin-nav/Nav.js